import urlUtil from 'common/util/url/urlUtil';

export interface ResolvedSectionQuestion {
    contentItemId?: number;
    contentRevisionId?: number;
    objectType?: string;
}

export function resolveActiveScorableItem(featureScorableItem = 1): number {
    const fromUrl = Number.parseInt(urlUtil.getUrlParam('scorableItem'), 10);
    return !Number.isNaN(fromUrl) && fromUrl > 0 ? fromUrl : featureScorableItem;
}

// The scorableItem URL/context param is 1-based; section.questions is 0-based. Falls back to the
// first question when scorableItem is missing/invalid.
function toQuestionIndex(scorableItem?: number): number {
    return typeof scorableItem === 'number' && !Number.isNaN(scorableItem) && scorableItem > 0
        ? scorableItem - 1
        : 0;
}

export function pickQuestionFromSection(sectionData: any, scorableItem?: number): ResolvedSectionQuestion | null {
    const resolvedQuestion = sectionData?.questions?.[toQuestionIndex(scorableItem)];
    const resolvedContentItemId = resolvedQuestion?.contentItemId;

    if (resolvedContentItemId && resolvedContentItemId > 0) {
        return {
            contentItemId: resolvedContentItemId,
            contentRevisionId: resolvedQuestion?.contentRevisionId,
            objectType: resolvedQuestion?.objectType,
        };
    }

    return null;
}
